import * as Yup from 'yup';

import {
    EMAIL_REGEX,
    SPECIAL_CHAR_REGEX,
    UPPERCASE_REGEX,
    NUMBERS_ONLY_REGEX,
    SOCIAL_MEDIA_REGEX,
    WEBSITE_REGEX,
} from './regexConstants';

export const LogInValidationSchema = Yup.object().shape({
    email: Yup.string()
        .matches(EMAIL_REGEX, 'Please enter a valid email address')
        .max(100, 'Email address cannot be more than 100 characters')
        .required('Email address is required')
        .label('Email'),

    password: Yup.string().required('Password is required').label('Password'),
});

export const ForgotValidationSchema = Yup.object().shape({
    email: Yup.string()
        .matches(EMAIL_REGEX, 'Please enter a valid email address')
        .max(100, 'Email address cannot be more than 100 characters')
        .required('Email address is required'),
});

export const ResetPasswordValidationSchema = Yup.object().shape({
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(UPPERCASE_REGEX, 'Password must contain at least one uppercase letter')
        .matches(SPECIAL_CHAR_REGEX, 'Password must contain at least one special character')
        .required('Password is required'),

    confirmPassword: Yup.string()
        .required('Confirm Password is required')
        .oneOf([Yup.ref('password')], 'Passwords must match'),

    uidb64: Yup.string().required('Invalid link. Missing user ID.'),
    token: Yup.string().required('Invalid link. Missing token.'),
});

export const ChangePasswordValidationSchema = Yup.object().shape({
    newPassword: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(UPPERCASE_REGEX, 'Password must contain at least one uppercase letter')
        .matches(SPECIAL_CHAR_REGEX, 'Password must contain at least one special character')
        .required('Password is required'),

    confirmNewPassword: Yup.string()
        .required('Confirm Password is required')
        .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
});

export const UserProfileValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    businessName: Yup.string(),
    email: Yup.string()
        .matches(EMAIL_REGEX, 'Please enter a valid email address')
        .max(100, 'Email address cannot be more than 100 characters')
        .required('Email address is required'),
    profilePicture: Yup.string().nullable(),
});

export const TeamMemberValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    profilePicture: Yup.string().nullable(),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(UPPERCASE_REGEX, 'Password must contain at least one uppercase letter')
        .matches(SPECIAL_CHAR_REGEX, 'Password must contain at least one special character')
        .required('Password is required'),

    confirmPassword: Yup.string()
        .required('Confirm Password is required')
        .oneOf([Yup.ref('password')], 'Passwords must match'),
    token: Yup.string().required('Invalid link. Missing token.'),
});

export const RequestCompanyValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required('Company name is required')
        .max(255, 'Company name cannot exceed 255 characters')
        .min(3, 'Company name must be at least 3 characters long')
        .test('not-email', 'Company name cannot be an email address', value => !value || !EMAIL_REGEX.test(value))
        .test(
            'not-numbers-only',
            'Company name cannot be only numbers',
            value => !value || !NUMBERS_ONLY_REGEX.test(value)
        )
        .test('not-website', 'Company name cannot be a website link', value => !value || !WEBSITE_REGEX.test(value))
        .test(
            'not-social-media',
            'Company name cannot be a social media link',
            value => !value || !SOCIAL_MEDIA_REGEX.test(value)
        ),
});
